/**
 * Export Backup Download Formatter.
 */
window.exportBackupDownloadFormatter = function(value, row) {
    let html = '';
    if (row.raw_status == "completed") {
        html += '<a href="/admin/exports/backups/download/'+row.id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
